import { SKILLS } from "../data";
import { Reveal, Eyebrow } from "./AmberCallout";

const Skills = () => (
  <section id="skills" data-testid="skills-section" className="py-20 sm:py-28 lg:py-32 bg-parchment2/60 scroll-mt-20">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Eyebrow>Skills</Eyebrow>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ink max-w-2xl leading-tight">
          How I work, and what I bring.
        </h2>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
        {SKILLS.map((cat, i) => (
          <Reveal key={cat.id} delay={i * 0.07}>
            <div
              data-testid={`skills-category-${cat.id}`}
              className="bg-surface border border-line rounded-2xl p-6 h-full hover:border-terra/50 transition-colors duration-300"
            >
              <h3 className="font-serif text-lg font-medium text-ink">{cat.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {cat.items.map((item) => (
                  <li key={item} className="flex gap-2.5 text-sm text-ink2 leading-relaxed">
                    <span className="mt-[0.55em] w-3 h-px bg-terra shrink-0" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Skills;
